import React from "react";

export default function NormalText(props) {
  return <p className="sp-block sp-text">{props.text}</p>;
}
